import React, { Fragment, useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import Select from "react-select";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import {
  Row,
  Col,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { Btn, H4, Spinner, LI } from "../../../AbstractElements";
import {
  EditProfile,
  Company,
  Username,
  UsersCountryMenu,
  AboutMe,
  UpdateProfile,
  FirstName,
  LastName,
  Address,
  EmailAddress,
  PostalCode,
  Country,
  City,
} from "../../../Constant";
import Dropzone1 from "../../Bonus UI/Dropzones/Dropzone1";
import SingleSelect from "../../SingleSelect/SingleSelect";
import axios from "axios";

const EditMyProfile = () => {
  const [name, setName] = React.useState("");
  const token = localStorage?.getItem("token");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const num = localStorage?.getItem("currentUser");
  const nameA = localStorage?.getItem("Name");
  const [phone_number, setPhoneNumber] = React.useState("");
  const [same, setSame] = React.useState(false);
  const [person_name, setPersonName] = React.useState("");
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [error, setError] = useState(null);
  const [otherDoc, setOtherDoc] = useState([]);
  const [position, setPosition] = useState("");
  const [signature, setSignature] = useState("");
  const [nameOfFirm, setNameOfFirm] = useState("");
  const [address, setAddress] = useState("");
  const [stampOfFirm, setStampOfFirm] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [email, setEmail] = useState("");
  const [emailValid, setEmailValid] = useState(true);
  const [nameOfOrganization, setNameOfOrganization] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [province, setProvince] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [profilePic, setProfilePic] = useState("");
  const [currentUpload, setCurrentUpload] = useState("");
  const [nextPage, setNextPage] = useState(false);
  const [proofPic, setProofPic] = useState("");
  const [stampPic, setStampPic] = useState("");
  const [supportingPic, setSupportingPic] = useState();
  const [supportingPic2, setSupportingPic2] = useState();
  const [regisPic, setRegisPic] = useState("");
  const [profile_status, setProfileStatus] = useState(false);
  const [proofPicS, setProofPicS] = useState("");
  const [stampPicS, setStampPicS] = useState("");
  const [regisPicS, setRegisPicS] = useState("");
  const [profilePicS, setProfilePicS] = useState("");

  const validateEmail = (em) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(em).toLowerCase());
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onEditSubmit = (data, files, allFiles) => {
    allFiles.forEach((f) => f.remove());
    toast.success("Dropzone successfully submitted !");
    alert("Form is Submitted");
  };

  const getUploadParams = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };

  const validateImageDimensions2 = (file, callback) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new window.Image();;
      img.src = event.target.result;

      img.onload = () => {
        const maxWidth = 160; // Maximum allowed width
        const maxHeight = 160; // Maximum allowed height

        if (img.width > maxWidth || img.height > maxHeight) {
          callback(
            false,
            `Image dimensions must be smaller than ${maxWidth}x${maxHeight}px. Uploaded image size: ${img.width}x${img.height}px.`
          );
        } else {
          callback(true);
        }
      };
    };
    reader.readAsDataURL(file);
  };

  const handleChangeStatus = async ({ meta, file, remove }, status) => {
    if (status === 'done') {
      try {
        // Resize the image to fit within a 134x170 box
        const resizedFile = await resizeImage(file, 160, 160);

        console.log('Original file size:', file.size);
        console.log('Resized file size:', resizedFile.size);

        // Set the new, resized file in your state
        setStampPic(resizedFile);

        toast.success('Image has been resized and is ready!');

      } catch (error) {
        console.error('Image processing failed:', error);
        toast.error('Could not process the image. Please try a different file.');
        remove(); // Remove the file from the dropzone on error
      }
    }

    if (status === 'removed') {
      // Handle file removal if needed
      setStampPic(null);
    }
  };


  const getUploadParams2 = ({ meta }) => {

    return { url: "https://httpbin.org/post" };
  };
  const handleChangeStatus2 = ({ meta, file }, status) => {

    setSupportingPic(file);
  };

  const getUploadParams3 = ({ meta }) => {

    return { url: "https://httpbin.org/post" };
  };
  const handleChangeStatus3 = ({ meta, file }, status) => {

    setSupportingPic2(file);
  };

  const getUploadParams5 = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };

  const handleChangeStatus5 = ({ meta, file }, status) => {
    if (status === 'done') {
      setOtherDoc((prev) => [...prev, file]); // Add file to the array
    } else if (status === 'removed') {
      setOtherDoc((prev) => prev.filter((f) => f !== file)); // Remove file from the array
    }
  };
  /*const handleSubmit = (files, allFiles) => {
    allFiles.forEach(f => f.remove());
    toast.success('Dropzone successfully submitted !');
  };*/

  const handleCheckboxChange = (e) => {
    if(nameA !== 'null') {
      setSame(e.target.checked);
      if(same) {
        setContactPerson('');
        setPhoneNumber('');
      } else {
        setContactPerson(nameA);
        setPhoneNumber(num);
      }
    } else {
      toast.error('There is no name currently.')
    }
  };

  const [provinceOption, setSelectedProvinceOption] =
    useState("Province No. 1");
    const [positionOption, setSelectedPositionOption] =
    useState("MD");
  const [districtOption, setSelectedDistrictOption] = useState("Biratnagar");
  const [cityOption, setSelectedCityOption] = useState("Bhojpur");
  const [titleOption, setSelectedTitleOption] = useState([{
    value: "Automobile Spare Parts",
    label: "Automobile Spare Parts",
  }]);
  const [nameValid, setNameValid] = useState(true);
  const [addressValid, setAddressValid] = useState(true);
  const [mobileValid, setMobileValid] = useState(true);
  const [positionValid, setPositionValid] = useState(true);
  const [panValid, setPanValid] = useState(true);
  const [stampValid, setStampValid] = useState(true);
  const [nameOfOrganizationValid, setNameOfOrganizationValid] = useState(true);
  const [contactPersonValid, setContactPersonValid] = useState(true);
  const [provinceValid, setProvinceValid] = useState(true);
  const [districtValid, setDistrictValid] = useState(true);
  const [districts, setDistricts] = useState([
    "Bhojpur",
    "Dhankuta",
    "Ilam",
    "Jhapa",
    "Khotang",
    "Morang",
    "Okhaldhunga",
    "Panchthar",
    "Sankhuwasabha",
    "Solukhumbu",
    "Sunsari",
    "Taplejung",
    "Terhathum",
    "Udayapur",
  ]);
  const [cities, setCities] = useState(["Biratnagar", "Dharan", "Itahari"]);
  const [cityValid, setCityValid] = useState(true);
  const [phoneNumberValid, setPhoneNumberValid] = useState(true);
  const [profilePicValid, setProfilePicValid] = useState(true);
  const [longitudeValid, setLongitudeValid] = useState(true);
  const [latitudeValid, setLatitudeValid] = useState(true);
  const [typeOfOrganizationValid, setTypeOfOrganizationValid] = useState(true);
  const [proofPicValid, setProofPicValid] = useState(true);

  const [filteredDistricts, setFilteredDistricts] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);

  const [selectedRadioIndex, setSelectedRadioIndex] = useState();

  const titles = [
    { value: "Automobile Spare Parts", label: "Automobile Spare Parts" },
    { value: "Accessories", label: "Accessories" },
    { value: "Tools", label: "Tools" },
    { value: "Batteries", label: "Batteries" },
    { value: "Tyres & Tubes", label: "Tyres & Tubes" },
    { value: "Lubricants", label: "Lubricants" },
    { value: "Vehicles", label: "Vehicles" },
    { value: "Motorcycle", label: "Motorcycle" },
    { value: "Tractor", label: "Tractor" },
    { value: "Tempo", label: "Tempo" },
    { value: "Heavy Equipments", label: "Heavy Equipments" },
    { value: "Workshop Equipments", label: "Workshop Equipments" },
  ];

  const provinces = [
    "Province No. 1",       // Formerly Province No. 1
    "Province No. 2",     // Formerly Province No. 2
    "Bagmati Province",
    "Gandaki Province",
    "Lumbini Province",
    "Karnali Province",
    "Sudurpashchim Province",
  ];

  const positions = [
    "MD",
    "Director",
    "CEO",
    "Manager",
    "Proprietor",
    "Other",
  ];

  const unfilteredDistricts = {
    "Province No. 1": [
      "Bhojpur",
      "Dhankuta",
      "Ilam",
      "Jhapa",
      "Khotang",
      "Morang",
      "Okhaldhunga",
      "Panchthar",
      "Sankhuwasabha",
      "Solukhumbu",
      "Sunsari",
      "Taplejung",
      "Terhathum",
      "Udayapur",
    ],
    "Province No. 2": [
      "Bara",
      "Dhanusha",
      "Mahottari",
      "Parsa",
      "Rautahat",
      "Saptari",
      "Sarlahi",
      "Siraha",
    ],
    "Bagmati Province": [
      "Bhaktapur",
      "Chitwan",
      "Dhading",
      "Dolakha",
      "Kathmandu",
      "Kavrepalanchok",
      "Lalitpur",
      "Makwanpur",
      "Nuwakot",
      "Ramechhap",
      "Rasuwa",
      "Sindhuli",
      "Sindhupalchok",
    ],
    "Gandaki Province": [
      "Baglung",
      "Gorkha",
      "Kaski",
      "Lamjung",
      "Manang",
      "Mustang",
      "Myagdi",
      "Nawalparasi East", // Corresponds to NAWALPUR in some datasets
      "Parbat",
      "Syangja",
      "Tanahu",
    ],
    "Lumbini Province": [
      "Arghakhanchi",
      "Banke",
      "Bardiya",
      "Dang",
      "Gulmi",
      "Kapilvastu",
      "Nawalparasi West", // Corresponds to PARASI in some datasets
      "Palpa",
      "Pyuthan",
      "Rolpa",
      "Rukum East",      // Corresponds to RUKUM_E in your file
      "Rupandehi",
    ],
    "Karnali Province": [
      "Dailekh",
      "Dolpa",
      "Humla",
      "Jajarkot",
      "Jumla",
      "Kalikot",
      "Mugu",
      "Rukum West",
      "Salyan",
      "Surkhet",
    ],
    "Sudurpashchim Province": [
      "Achham",
      "Baitadi",
      "Bajhang",
      "Bajura",
      "Dadeldhura",
      "Darchula",
      "Doti",
      "Kailali",
      "Kanchanpur",
    ],
  };

  const unfilteredCities = {
    "Province No. 1": [
      "Aathrai Tribeni", "Arjundhara", "Barahachhetra", "Barhadashi",
      "Belaka", "Bhojpur", "Biratnagar", "Birtamod", "Buddhashanti",
      "Chainpur", "Chulachuli", "Chisangkhugadhi", "Damak", "Deumai",
      "Dhankuta", "Dharan", "Falelung", "Falgunanda", "Gauradhaha",
      "Haldibari", "Hatuwagadhi", "Ilam", "Inaruwa", "Itahari", "Jahada",
      "Kachankawal", "Kamal", "Katari", "Kepilasgadhi", "Khumbupasanglahmu",
      "Kummayak", "Letang", "Likhu", "Maijogmai", "Maiwakhola", "Manebhanjyang",
      "Mangsebung", "Meringden", "Miklajung", "Morang", "Pathari Shanischare",
      "Panchakanya", "Phidim", "Ratuwamai", "Rong", "Sandakpur",
      "Shivasatakshi", "Sidingba", "Sirijangha", "Solududhkunda",
      "Sundarharaincha", "Suryodaya", "Taplejung", "Tehrathum",
      "Udayapurgadhi", "Urlabari", "Yangwarak"
    ],
    "Province No. 2": [
      "Adarshkotwal", "Aurahi", "Bagmati", "Bishnupur", "Birgunj",
      "Chhinnamasta", "Gaushala", "Godaita", "Haripur", "Haripurwa",
      "Ishnath", "Janakpur", "Jitpur Simara", "Kalaiya", "Karjanha",
      "Lahan", "Mahagadhimai", "Manara Shiswa", "Matihani", "Paroha",
      "Patarauta", "Pokhariya", "Rajbiraj", "Sabaila", "Sarlahi"
    ],
    "Bagmati Province": [
      "Bagmati", "Banepa", "Belkotgadhi", "Benighatrorang", "Bethanchok",
      "Bhaktapur", "Bharatpur", "Bhimeshwor", "Bhumlu", "Bidur", "Chaurideurali",
      "Chitwan", "Dhading", "Dhunibeshi", "Dhulikhel", "Doramba", "Gajuri",
      "Galchhi", "Gokulganga", "Hetauda", "Indrasarowar", "Jugal", "Kageshwari Manohara",
      "Kalinchok", "Kamalamai", "Kathmandu", "Kavrepalanchok", "Khanikhola",
      "Lalitpur", "Likhu Tamakoshi", "Lisankhu Pakhar", "Madanpur", "Mahabharat",
      "Makwanpurgadhi", "Mandandeupur", "Manthali", "Melamchi", "Namobuddha",
      "Narayani", "Nilkantha", "Panchakanya", "Panchpokhari Thangpal", "Panauti",
      "Phikkal", "Ramechhap", "Rasuwa", "Rautamai", "Roshiba", "Ruby Valley",
      "Shailung", "Sindhuli", "Sindhupalchok", "Sunkoshi", "Suryabinayak",
      "Tarkeshwar", "Thaha", "Tokha", "Tripurasundari", "Umakunda"
    ],
    "Gandaki Province": [
      "Aanbukhaireni", "Aarughat", "Ajirkot", "Annapurna", "Baglung",
      "Bandipur", "Barpak Sulikot", "Besisahar", "Bhanu", "Bhimad",
      "Bim", "Chame", "Chunumanubri", "Galkot", "Gandaki", "Gharapjhong",
      "Gorkha", "Harinas", "Jaimini", "Kaski", "Kawasoti", "Lamjung",
      "Machhapuchchhre", "Madi", "Manang", "Marsyangdi", "Modi", "Mustang",
      "Myagdi", "Nishi", "Palungtar", "Parbat", "Pokhara", "Putalibazar",
      "Rainas", "Rishing", "Rupa", "Sarkhu", "Shahid Lakhan", "Syangja",
      "Tanahu", "Tarakhola", "Thasang"
    ],
    "Lumbini Province": [
      "Airawati", "Arghakhanchi", "Badhaiyatal", "Banganga", "Banglachuli",
      "Banke", "Bardaghat", "Bardiya", "Bhumekasthan", "Buddhabhumi",
      "Butwal", "Chhatradev", "Dang", "Dangisharan", "Devdaha",
      "Dhorpatan Hunting Reserve", "Gadhawa", "Gaumukhi", "Geruwa", "Ghorahi",
      "Gulariya", "Gulmi", "Jhimruk", "Kapilvastu", "Krishnanagar",
      "Lumbini Sanskritik", "Lumbini", "Machhapuchhre", "Maharajgunj",
      "Malika", "Mandandeupur", "Mathagadhi", "Mayadevi", "Naubahini",
      "Omsatiya", "Palpa", "Panini", "Pratappur", "Putha Uttarganga",
      "Pyuthan", "Raina Devi Chhahara", "Rampur", "Ribdikot", "Rohini",
      "Rolpa", "Runtigadhi", "Rupandehi", "Sainamaina", "Sammarimai",
      "Sandhikharka", "Sarawal", "Shiwapur", "Shivaraj", "Shuddhodhan",
      "Siddharthanagar", "Sisne", "Sunawal", "Siyari", "Tansen", "Thawang",
      "Tilottama", "Tulsipur", "Yashodhara"
    ],
    "Karnali Province": [
      "Aathbiskot", "Barekot", "Bheriganga", "Bheri", "Birkot", "Chaukune",
      "Chhedagad", "Chhayanath Rinpoche", "Dailekh", "Darma", "Dullu",
      "Gurbhakot", "Hima", "Jagadulla", "Jajarkot", "Jumla", "Kalikot",
      "Kankasundari", "Khatyad", "Kumakh", "Lekbesi", "Mahabu", "Mugu",
      "Naumule", "Panchapuri", "Patarasi", "Raskot", "Salyan", "Shantinagar",
      "Simkot", "Sinja", "Soru", "Subha Kalika", "Surkhet", "Tatopani",
      "Thuli Bheri", "Tilagupha", "Tripurasundari"
    ],
    "Sudurpashchim Province": [
      "Ajaymeru", "Alital", "Amargadhi", "Apihimal", "Badikedar",
      "Bhageshwar", "Chure", "Dadeldhura", "Dasharathchanda", "Dhangadhi",
      "Dipayal Silgadhi", "Dogadakedar", "Ganayapdhura", "Ghodaghodi",
      "Godawari", "Gulariya", "Janaki", "Joshipur", "Kailali", "Kailari",
      "Kanchanpur", "Krishnapur", "Laljhadi", "Lamkichuha", "Mahakali",
      "Melauli", "Mohanyal", "Nawadurga", "Parashuram", "Patan",
      "Puchaundi", "Punarbas", "Shikhar", "Shuklaphanta National Park",
      "Shuklaphanta", "Sigas", "Simta", "Surnaya", "Tikapur"
    ]
  };

  useEffect(() => {

    setSelectedDistrictOption(unfilteredDistricts[provinceOption][0]);
    setSelectedCityOption(unfilteredCities[provinceOption][0]);
    setDistricts(unfilteredDistricts[provinceOption] || []);

    setCities(unfilteredCities[provinceOption] || []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provinceOption]);

  const getLocation = (e) => {
    e.preventDefault();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {

          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
          setError(null);
        },
        (error) => {

          setError(error.message);
        }
      );
    } else {
      setError("Geolocation is not supported by this browser.");

    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if (
      /*name?.trim() !== "" &&
      (profilePicS !== "" || profilePic !== "") &&
      panNumber?.trim() !== "" &&
      stampPic !== "" &&
      (positionOption === 'Other'? position?.trim() !== "" : true) &&
      (!same ? contactPerson?.trim() !== "" && phone_number?.length === 10 : true) &&
      (email?.trim() !== ""? validateEmail(email) : true)*/ true
    ) {
      try {

        setLoading(true);
        let stamp;
        let pp;
        let support;
        let support2;
        let otherDocy;

        if (profilePic) {
          pp = await call_picture_upload(profilePic);
        }
        if(stampPic) {
          stamp = await call_picture_upload(stampPic);
        }
        if(supportingPic) {
          support = await call_picture_upload(supportingPic);
        }
        if(supportingPic2) {
          support2 = await call_picture_upload(supportingPic2);
        }

        if(otherDoc?.length > 0) {
          otherDocy = await Promise.all(
            otherDoc.map((file) => call_picture_upload(file)));
        }

        const response2 = await axios.post(
          "https://api-portal.nada.org.np/api/firms",
          {
            name_of_firm: name,
            pan_number: panNumber,
            province: provinceOption,
            stamp_of_firm: stamp? stamp: '',
            type_of_organization: titleOption?.length > 1 ? titleOption?.map(option => option.value).join(',') : titleOption?.[0]?.value,
            contact_person_num: phone_number,
            supporting_document: support? support : '',
            supporting_document2: support2? support2 : '',
            address: address,
            other_document: otherDocy ? otherDocy : [],
            email: email,
            district: districtOption,
            contact_person: contactPerson,
            city: cityOption,
            latitude: latitude,
            longitude: longitude,
            pp_image: profilePicS
              ? profilePicS
              : pp
              ? pp
              : "",
            position: positionOption === 'Other' ? position : positionOption,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "access-control-allow-origin": "*",
              'Authorization': `Bearer ${token}`,
            },
          }
        );

        if (response2?.data?.success) {
          setLoading(false);
          toast.success("Firm submitted successfully.");
          navigate("/firms");
          //setData(response2?.data?.data?.firms);
        }
      } catch (error) {
        setLoading(false);
        if (error.response) {
          console.error("Error response:", error?.response);
          toast.error(error?.response?.data?.message || "An error occurred");
        } else if (error?.request) {
          console.error("Error request:", error?.request);
          toast.error("No response received from server");
        } else {
          console.error("Error message:", error?.message);
          toast.error(error?.message);
        }
      }
    } else {
      if (name?.trim() === "") {
        setNameValid(false);
      } else {
        setNameValid(true);
      }


      if (positionOption === 'Other') {
        setPositionValid(position?.trim() !== "");
      } else {
        setPositionValid(true); // Automatically valid for any other option
      }

      setEmailValid(email?.trim() !== ""? validateEmail(email) : true);

      if (panNumber === "") {
        setPanValid(false);
      } else {
        setPanValid(true);
      }

      if (address === "") {
        setAddressValid(false);
      } else {
        setAddressValid(true);
      }

        if (profilePic === "" && profilePicS === "") {
          setProfilePicValid(false);
        } else {
          setProfilePicValid(true);
        }

        if (stampPic === "") {
          setStampValid(false);
        } else {
          setStampValid(true);
        }


      if (!same) {
        if (contactPerson === "") {
          setContactPersonValid(false);
        } else {
          setContactPersonValid(true);
        }
        if (phone_number?.length !== 10) {
          setPhoneNumberValid(false);
        } else {
          setPhoneNumberValid(true);
        }
      } else {
        setContactPersonValid(true);
        setPhoneNumberValid(true);
      }
    }
  };

  const call_picture_upload = async (file) => {
    // 1. Get the Presigned URL
    const getUrl = await axios.get(
      `https://api-portal.nada.org.np/api/upload-url?filename=${file.name}&fileType=${file.type}`,
      {
        headers: {
             // Ensure you are sending auth if your backend requires it
            'Authorization': `Bearer ${token}`
        },
      }
    );

    const { uploadUrl, key } = getUrl.data;

    // 2. Upload to S3 (Crucial Fix Here)
    await axios.put(
      uploadUrl,
      file, // <--- Pass 'file' directly. Do NOT wrap in { body: file }
      {
        headers: {
            "Content-Type": file.type
        }
      }
    );

    return "https://d24xzirvx50zjt.cloudfront.net/" + key;
};
  const resizeImage = (file, maxWidth, maxHeight) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (event) => {
        const img = new window.Image();
        img.src = event.target.result;

        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          let width = img.width;
          let height = img.height;

          // Calculate the new dimensions to maintain aspect ratio
          if (width > height) {
            if (width > maxWidth) {
              height = Math.round(height * (maxWidth / width));
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width = Math.round(width * (maxHeight / height));
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;

          // Draw the resized image onto the canvas
          ctx.drawImage(img, 0, 0, width, height);

          // Convert canvas to a Blob, then to a File
          canvas.toBlob(
            (blob) => {
              if (!blob) {
                reject(new Error('Canvas to Blob conversion failed.'));
                return;
              }
              const resizedFile = new File([blob], file.name, {
                type: file.type,
                lastModified: Date.now(),
              });
              resolve(resizedFile);
            },
            file.type,
            0.95 // Image quality for JPEG/WEBP (0.0 to 1.0)
          );
        };

        img.onerror = (error) => reject(error);
      };

      reader.onerror = (error) => reject(error);
    });
  };


  const getUploadParams4 = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };

  const validateImageDimensions = (file, callback) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new window.Image();;
      img.src = event.target.result;

      img.onload = () => {
        const maxWidth = 134; // Maximum allowed width
        const maxHeight = 170; // Maximum allowed height

        if (img.width > maxWidth || img.height > maxHeight) {
          callback(
            false,
            `Image dimensions must be ${maxWidth}x${maxHeight}px. Uploaded image size: ${img.width}x${img.height}px.`
          );
        } else {
          callback(true);
        }
      };
    };
    reader.readAsDataURL(file);
  };

  const handleChangeStatus4 = async ({ meta, file, remove }, status) => {
    if (status === 'done') {
      try {
        // Resize the image to fit within a 134x170 box
        const resizedFile = await resizeImage(file, 134, 170);

        console.log('Original file size:', file.size);
        console.log('Resized file size:', resizedFile.size);

        // Set the new, resized file in your state
        setProfilePic(resizedFile);

        toast.success('Image has been resized and is ready!');

      } catch (error) {
        console.error('Image processing failed:', error);
        toast.error('Could not process the image. Please try a different file.');
        remove(); // Remove the file from the dropzone on error
      }
    }

    if (status === 'removed') {
      // Handle file removal if needed
      setProfilePic(null);
    }
  };

  const handleClick = (link, e) => {
    e.preventDefault();
    window.open(link, "_blank", "noopener,noreferrer");
  };



  return (
    <Fragment>
      <Form className="card" onSubmit={(e) => handleAdd(e)}>
        <CardHeader className="pb-0">
          <div className="card-options">
            <a className="card-options-collapse" href="#javascript">
              <i className="fe fe-chevron-up"></i>
            </a>
            <a className="card-options-remove" href="#javascript">
              <i className="fe fe-x"></i>
            </a>
          </div>
        </CardHeader>
        <CardBody>
          <Row>
            <Col md="5">
              <FormGroup className="mb-3">
                {" "}
                <Label className="form-label">{t("Name of Firm")}</Label>
                <input
                  className="form-control"
                  name="name"
                  type="text"
                  placeholder={t("Name")}
                  style={{ borderColor: !nameValid ? "#EB0A1E" : null }}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <span style={{ color: "red" }}>
                {!nameValid && `${t("Name is required")}`}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <FormGroup>
                {" "}
                <Label className="form-label">{t("Pan Number")}</Label>
                <input
                  className="form-control"
                  name="phone"
                  type="text"
                  style={{ borderColor: !panValid ? "#EB0A1E" : null }}
                  placeholder={t("Pan Number")}
                  value={panNumber}
                  onChange={(e) => setPanNumber(e.target.value)}
                  //{...register("pan", { required: true })}
                />
                <span style={{ color: "red" }}>
                  {!panValid && `${t("Pan Number is required")}`}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="4">
              <div style={{ marginTop: -8 }}>
                <Label className="col-form-label">{t("Type of Firm")}</Label>
                <Select
                  options={titles}
                  value={titleOption}
                  onChange={setSelectedTitleOption}
                  className="js-example-basic-single col-sm-12"
                  isMulti
                />
              </div>
            </Col>
            <Col sm="6" md="3">
              <FormGroup>
                <Label className="form-label">{t("Email")}</Label>
                <input
                  className="form-control"
                  name="email"
                  type="text"
                  style={{
                    borderColor: !emailValid ? "#EB0A1E" : null,
                  }}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t("Email")}
                  //{...register("FirstName", { required: true })}
                />
                 <span style={{ color: "red" }}>
                  {!emailValid && t("Email is invalid")}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <FormGroup>
                <Label className="form-label">{t("Contact Person")}</Label>
                <input
                  className="form-control"
                  name="FirstName"
                  type="text"
                  style={{ borderColor: !contactPersonValid ? "#EB0A1E" : null }}
                  disabled={same}
                  value={contactPerson}
                  onChange={(e) => setContactPerson(e.target.value)}
                  placeholder={t("Contact Person")}
                  //{...register("FirstName", { required: true })}
                />
                <span style={{ color: "red" }}>
                  {!contactPersonValid && t("Contact Person is required")}{" "}
                </span>
                <div className="form-check form-check-inline checkbox checkbox-primary">
                  <Input
                    id="inline-form-1"
                    type="checkbox"
                    checked={same}
                    onChange={handleCheckboxChange}
                  />
                  <Label className="mb-0" htmlFor="inline-form-1">
                    {t("same as logged user?")}
                  </Label>
                </div>
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <FormGroup>
                <Label className="form-label">{t("Phone Number")}</Label>
                <input
                  className="form-control"
                  name="phone"
                  type="text"
                  disabled={same}
                  style={{ borderColor: !phoneNumberValid ? "#EB0A1E" : null }}
                  placeholder={t("Phone Number")}
                  value={phone_number}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  //{...register("phone", { required: true })}
                />
                <span style={{ color: "red" }}>
                  {!phoneNumberValid && t("Phone Number is required")}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <FormGroup>
                <Label className="form-label">{t("Position")}</Label>
                <SingleSelect
                  options={positions}
                  selectedOption={positionOption}
                  onChange={setSelectedPositionOption}
                />
                {positionOption === 'Other' &&
                <input
                  className="form-control"
                  name="phone"
                  type="text"
                  disabled={same}
                  style={{ borderColor: !positionValid ? "#EB0A1E" : null, marginTop: 6 }}
                  placeholder={t("Specify..")}
                  value={position}
                  onChange={(e) => setPosition(e.target.value)}
                  //{...register("phone", { required: true })}
                />
                }
                <span style={{ color: "red" }}>
                  {!positionValid && t("Position is required")}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <div>
                {" "}
                <Label className="form-label">
                  {t("Update Contact Person Passport Photo")}(jpeg/png,134 * 170)
                </Label>
                <Dropzone1
                  accept="image/jpeg,image/png"
                  getUploadParams={getUploadParams4}
                  handleChangeStatus={handleChangeStatus4}
                  placeholder={t("Photo")}
                />
                <span style={{ color: "red" }}>
                  {!profilePicValid && t("Passport Size Photo is required")}{" "}
                </span>
              </div>
            </Col>
            <Col sm="6" md="3">
              <div>
                <Label className="col-form-label">{t("Province")}</Label>
                <SingleSelect
                  options={provinces}
                  selectedOption={provinceOption}
                  onChange={setSelectedProvinceOption}
                />
              </div>
            </Col>
            <Col sm="6" md="3">
              <div>
                <Label className="col-form-label">{t("District")}</Label>
                <SingleSelect
                  options={districts}
                  selectedOption={districtOption}
                  onChange={setSelectedDistrictOption}
                />
              </div>
            </Col>
            <Col sm="6" md="3">
              <div>
                <Label className="col-form-label">{t("City")}</Label>
                <SingleSelect
                  options={cities}
                  selectedOption={cityOption}
                  onChange={setSelectedCityOption}
                />
              </div>
            </Col>
            <Col sm="6" md="3" style={{ marginTop: 6 }}>
              <FormGroup>
                <Label className="form-label">{t("Address")}</Label>
                <input
                  className="form-control"
                  name="phone"
                  style={{ borderColor: !addressValid ? "#EB0A1E" : null }}
                  type="text"
                  placeholder={t("Address")}
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  //{...register("address", { required: true })}
                />
                <span style={{ color: "red" }}>
                  {!addressValid && t("Address is required")}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <FormGroup>
                {" "}
                <Label className="form-label">{t("Firm Latitude")}</Label>
                <input
                  className="form-control"
                  name="phone"
                  type="text"
                  style={{ borderColor: !latitudeValid ? "#EB0A1E" : null }}
                  placeholder={t("Firm Latitude")}
                  value={latitude}
                  onChange={(e) => setLatitude(e.target.value)}
                  //{...register("pan", { required: true })}
                />
                <span style={{ color: "red" }}>
                {!latitudeValid && "Latitude is required"}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="3">
              <FormGroup>
                {" "}
                <Label className="form-label">{t("Firm Longitude")}</Label>
                <input
                  className="form-control"
                  name="longitude"
                  type="text"
                  style={{ borderColor: !longitudeValid ? "#EB0A1E" : null }}
                  placeholder={t("Firm Longitude")}
                  value={longitude}
                  onChange={(e) => setLongitude(e.target.value)}
                  //{...register("longitude", { required: true })}
                />
                <span style={{ color: "red" }}>
                {!longitudeValid && "Longitude is required"}{" "}
                </span>
              </FormGroup>
            </Col>
            <Col sm="6" md="3" style={{ marginTop: 27 }}>
              <Btn
                attrBtn={{
                  color: "primary",
                  type: "submit",
                  onClick: (e) => getLocation(e),
                }}
              >
                {t("Set Current Location")}
              </Btn>
            </Col>
            <Col sm="6" md="4">
              <div>
                {" "}
                <Label className="form-label">{t("Upload Stamp of firm")}(jpeg/png,160 * 160)</Label>
                <Dropzone1
                  accept="image/jpeg,image/png"
                  getUploadParams={getUploadParams}
                  handleChangeStatus={handleChangeStatus}
                  placeholder={t("Stamp")}
                />
              </div>
              <span style={{ color: "red" }}>
                {!stampValid && t("Stamp Image is required")}{" "}
              </span>
            </Col>
            <Col sm="6" md="4">
              <div>
                {" "}
                <Label className="form-label">{t("Upload Suporting Document")}</Label>
                <Dropzone1
                  getUploadParams={getUploadParams2}
                  handleChangeStatus={handleChangeStatus2}
                  placeholder={t("NADA Document")}
                />
              </div>
            </Col>
            <Col sm="6" md="4">
              <div>
                {" "}
                <Label className="form-label">
                {t("Upload Another Suporting Document")}
                </Label>
                <LI>{t("ncell1")}</LI>
                <LI>{t("ncell2")}</LI>
                <LI>{t("ncell3")}</LI>
                <Dropzone1
                  getUploadParams={getUploadParams3}
                  handleChangeStatus={handleChangeStatus3}
                  placeholder={t("Phone number owner's proof.")}
                />
              </div>
            </Col>
            <Col sm="7" md="8">
              <div>
                {" "}
                <Label className="form-label">{t("Other Documents Upload")}(pdf/png/jpeg)</Label>
                <Dropzone1
                  multi={true}
                  noOfFiles={4}
                  getUploadParams={getUploadParams5}
                  handleChangeStatus={handleChangeStatus5}
                   placeholder="NADA Document."
                />
              </div>
            </Col>
          </Row>
        </CardBody>
        <CardFooter className="text-end">
          {
            loading?
              <div className="loader-box">
              <Spinner attrSpinner={{ className: 'loader-2' }} />
            </div> : <Btn attrBtn={{ color: "primary", type: "submit" }}>{t("Add Firm")}</Btn>
          }
        </CardFooter>
      </Form>
    </Fragment>
  );
};
export default EditMyProfile;
